export const returnType = (type) => {
  switch (type) {
    case "name":
      return "이름";
      break;
    case "email":
      return "이메일";
      break;
    case "password":
      return "비밀번호";
      break;
    case "phone":
      return "휴대폰번호";
      break;
    default:
      return "";
  }
};
export const returnTypeIs = (type) => {
  switch (type) {
    case "name":
      return "이름이";
      break;
    case "email":
      return "이메일 주소가";
      break;
    case "password":
      return "비밀번호가";
      break;
    case "phone":
      return "휴대폰번호가";
      break;
    default:
      return "";
  }
};
export const returnOptionText = (type) => {
  switch (type) {
    case 0:
      return "전체";
      break;
    case 1:
      return "적립";
      break;
    case 2:
      return "사용";
      break;
    case 3:
      return "교환";
      break;
    case 4:
      return "스왑";
      break;
    case 5:
      return "적립취소";
      break;
    case 6:
      return "사용취소";
      break;
    case 7:
      return "소멸";
      break;
    default:
      return "전체";
  }
};

// 카테고리(1:1 문의내역,faq)
export const returnInquireCategory = (status) => {
  let resp;
  switch (status) {
    case 1:
      resp = "회원가입/탈퇴";
      break;
    case 2:
      resp = "포인트";
      break;
    case 3:
      resp = "월렛";
      break;
    case 4:
      resp = "스왑";
      break;
    case 5:
      resp = "AMO 코인";
      break;
    case 6:
      resp = "기타";
      break;
    default:
      resp = "-";
  }
  return resp;
};

export const timeChange = (time) => {
  if (time == 0 || time == null || time == "") return "-";
  let date = new Date(time);
  let year = date.getFullYear();
  let month = "0" + (date.getMonth() + 1);
  let day = "0" + date.getDate();
  let hour = "0" + date.getHours();
  let minute = "0" + date.getMinutes();
  let second = "0" + date.getSeconds();
  return (
    year +
    "-" +
    month.substr(-2) +
    "-" +
    day.substr(-2) +
    " " +
    hour.substr(-2) +
    ":" +
    minute.substr(-2) +
    ":" +
    second.substr(-2)
  );
};

export const textSubStr = (text) => {
  if (!text) return "";
  const dateValue = new Date(text);
  const year = dateValue.getFullYear();
  const month = String(dateValue.getMonth() + 1).padStart(2, "0");
  const day = String(dateValue.getDate()).padStart(2, "0");
  const hours = String(dateValue.getHours()).padStart(2, "0");
  const minutes = String(dateValue.getMinutes()).padStart(2, "0");
  const seconds = String(dateValue.getSeconds()).padStart(2, "0");
  const formattedDate = `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;

  let date = formattedDate.substr(0, 10);
  let time = formattedDate.substr(-8);
  return [date, time];
};

//생년월일 커스텀(회원가입 시)
export const returnParamsBirth = (yyyy, mm, dd) => {
  let res;
  mm = String(mm).padStart(2, "0");
  dd = String(dd).padStart(2, "0");
  res = yyyy + mm + dd;
  return res;
};

//생년월일 년,월,일 별로 자르기
export const returnSubstrBirth = (value, type) => {
  let res;
  if (!value) return;
  else {
    if (type == "yyyy") res = value.substr(0, 4);
    else if (type == "mm") res = value.substr(4, 2);
    else if (type == "dd") res = value.substr(6);
  }

  return res;
};

//return YYYY-MM-DD
export const returnYYYYMMDD = (date) => {
  let res;
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  res = [year, month, day].join("-");
  return res;
};

//하이픈 제거
export const removeHyphen = (value) => {
  if (!value) return;
  value = value.replace(/-/g, "");

  return value;
};

//천단위 콤마
export const replaceCommas = (value) => {
  // if (!value) return 0;
  // value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // return value;
  if (!value && value !== 0) return 0;

  // Convert to number if it's not already
  let numericValue = parseFloat(value);

  // Check if it's a valid number
  if (isNaN(numericValue)) return 0;

  // Check if there is a decimal part
  const hasDecimalPart = /\./.test(value);

  // Return integer if no decimal part
  if (!hasDecimalPart)
    return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Round to 4 decimal places
  numericValue = numericValue.toFixed(4);

  // Remove commas for thousands in the decimal part
  const [integerPart, decimalPart] = numericValue.split(".");
  const formattedDecimalPart = decimalPart
    ? `.${decimalPart.replace(/,/g, "")}`
    : "";

  // Add commas for thousands in the integer part
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  // Combine the formatted parts
  const formattedValue = `${formattedIntegerPart}${formattedDecimalPart}`;

  return formattedValue;
};

//입력시 콤마(천단위)
export function inputPriceFormat(str) {
  const comma = (str) => {
    str = String(str);
    return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
  };
  const uncomma = (str) => {
    str = String(str);
    return str.replace(/[^\d]+/g, "");
  };
  return comma(uncomma(str));
}

//콤마 제거
export function unComma(str) {
  str = String(str);
  str = str.replace(/[^\d]+/g, "");
  return Number(str);
}

//하이픈 추가 (핸드폰번호)
export const autoHyphen = (value) => {
  // const { name, value } = e.target;
  if (!value) return;
  let replacePhone;
  replacePhone = value
    .replace(/[^0-9]/g, "")
    .replace(/(\d{3})(\d{4})(\d{4})/g, `$1-$2-$3`)
    .replace(/(\\-{3,4})$/g, "");
  // setMyInfo((prev) => ({ ...prev, [name]: replacePhone }));
  return replacePhone;
};

export const checkMobile = () => {
  const varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

  if (varUA.indexOf("android") > -1) {
    //안드로이드
    return "android";
  } else if (
    varUA.indexOf("iphone") > -1 ||
    varUA.indexOf("ipad") > -1 ||
    varUA.indexOf("ipod") > -1
  ) {
    //IOS
    return "ios";
  } else {
    //아이폰, 안드로이드 외
    return "other";
  }
};

export const maskMiddle = (inputStr) => {
  if (!inputStr) return;
  if (inputStr.length <= 6) {
    return inputStr;
  } else {
    return inputStr.substring(0, 3) + "..." + inputStr.slice(-4);
  }
};

export const maskAddress = (address) => {
  // 주소 길이가 충분히 길어야 함을 확인
  if (address.length <= 24) {
    return address; // 예외 처리: 주소가 충분히 길지 않으면 그대로 반환
  }

  // 앞 14자리와 끝 10자리를 제외한 부분을 '...'으로 채워서 반환

  const maskedAddress =
    address.substring(0, 14) + "..." + address.substring(address.length - 10);

  return maskedAddress;
};
